// extracted by mini-css-extract-plugin
export default {"title":"styles_title__hmyIz","wrapper":"styles_wrapper__Q2xCi","wrapper_item":"styles_wrapper_item__j60Rv","wrapper_separator":"styles_wrapper_separator__5Oh2L"};